import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { TRANSCRIPT_ROUTES } from "TranscriptsV3/modules/constants";

export default store => ({
  path: TRANSCRIPT_ROUTES.TEMPLATE,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-v3-templates" */ "./components"
    ).then(m => m.default)
  ),
});
